import CryptoJS from "crypto-js";
import { DATA_KEY } from "../utils/constance";

export const encryptPayload = (pwd) => {
  const key = CryptoJS.enc.Utf8.parse(DATA_KEY);
  const hashedKey = CryptoJS.SHA256(key); // Hash the key to get a 256-bit key

  // Generate random IV (16 bytes for AES-256-CBC)
  const iv = CryptoJS.lib.WordArray.random(16);

  const encrypted = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(pwd),
    hashedKey,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    },
  );

  // Prepend the IV to the encrypted ciphertext for passing it along with the encrypted password
  const encryptedPayload =
    iv.toString(CryptoJS.enc.Base64) + ":" + encrypted.toString();

  return encryptedPayload;
};

// Decrypt function
export const decryptPayload = (encryptedPayload) => {
  try {
    const key = CryptoJS.enc.Utf8.parse(DATA_KEY); // Secret key
    const hashedKey = CryptoJS.SHA256(key); // Hash the key for AES-256 compatibility

    // Split the payload into IV and ciphertext
    const parts = encryptedPayload.split(":");
    if (parts.length !== 2) {
      throw new Error("Invalid encrypted payload format");
    }
    const iv = CryptoJS.enc.Base64.parse(parts[0]); // Extract IV
    const ciphertext = CryptoJS.enc.Base64.parse(parts[1]); // Extract ciphertext

    // Decrypt using AES-256-CBC
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: ciphertext },
      hashedKey,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      },
    );

    const plaintext = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plaintext); // Parse the decrypted JSON
  } catch (error) {
    console.error("Decryption failed:", error);
    throw new Error("Failed to decrypt the API response");
  }
};

export const dateFormat = (dateString = "") => {
  if (!dateString) {
    return null; // Explicitly return null for invalid input
  }

  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    console.error("Invalid date string:", dateString);
    return null; // Return null if the date is invalid
  }

  // Format date as DD-MM-YYYY
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = date.getFullYear();
  const formattedDate = `${year}-${month}-${day}`;

  // DateTime options
  const dateOptions = {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  };

  // Get formatted date and time (e.g., 26/12/24, 1:00:00 PM)
  const formattedDateTime = date.toLocaleString("en-GB", dateOptions);

  return { formattedDate, formattedDateTime };
};

export const generateRandomId = () => {
  const randomPart = Math.floor(Math.random() * 1000); // A 3-digit random number
  return (Date.now().toString().slice(-7) + randomPart).slice(-10);
};

export const currentDateTime = () => {
  const now = new Date(Date.now());
  const date = now.toISOString().split("T")[0];
  const time = now.toISOString().split("T")[1].split(".")[0];
  const dateTime = now.toISOString();

  return {
    date,
    time,
    dateTime,
  };
};

export const cleanUpValue = (value) => {
  if (!value) {
    return "";
  }
  return value?.replace(/\s*\(.*?\)/, "").trim();
};

export const generateOptions = () => {
  return Array.from({ length: 50 }, (_, i) => ({
    value: i + 1,
    label: i + 1,
  }));
};

export const normalizeName = (name) => {
  if (name.endsWith("es")) return name.slice(0, -2);
  if (name.endsWith("s")) return name.slice(0, -1);
  return name;
};

export function convertToAMPM(time) {
  if (!time) return "";
  let [hours, minutes] = time.split(":").map(Number);
  let period = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert 0 to 12 for 12 AM and 12 PM remains the same
  return `${hours}:${minutes.toString().padStart(2, "0")} ${period}`;
}

export function convertTo24Hour(time) {
  if (!time) return "";
  let [hourMinute, period] = time.split(" ");
  let [hours, minutes] = hourMinute.split(":").map(Number);

  if (period.toUpperCase() === "PM" && hours !== 12) {
    hours += 12;
  } else if (period.toUpperCase() === "AM" && hours === 12) {
    hours = 0;
  }

  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;
}
export const generateRandomRoomId = (length = 5) => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  return Array.from(
    { length },
    () => chars[Math.floor(Math.random() * chars.length)],
  ).join("");
};

// export const createBadla = ({ rowData, index, key, buySell = null }) => {
//   // rowData is not empty
//   if (!rowData) return 0;

//   const { marketType, instrumentsDetail, equation, settingValue, reverse } =
//     rowData; // destructure rowData
//   const PRICE = 10000; // global main price
//   const reverseVal = reverse ?? 0; // reverse default with 0 value

//   // handle 0th index data (MCX)
//   const diffValue = rowData?.diffrenceValue
//     ? instrumentsDetail[0][key] + rowData?.diffrenceValue
//     : instrumentsDetail[0][key];

//   // Check if marketType is "badla"
//   if (marketType && marketType?.toLowerCase() !== "badla") return 0;

//   // Calculate the dollar price
//   const modifyPrice = PRICE / instrumentsDetail[index][key];

//   // Create custom equation
//   const duty = settingValue?.[0]?.Duty;
//   const finalEqu = replaceAndEval({
//     equation,
//     modifyPrice,
//     key,
//     index,
//     instrumentsDetail,
//     duty,
//     buySell,
//     diffValue,
//   });

//   // handle finalEqu with reverse
//   const finalPrice =
//     reverseVal === 1 ? finalEqu - diffValue : diffValue - finalEqu;

//   return {
//     finalPrice: finalPrice?.toFixed(2) ?? 0,
//     finalEqu: finalEqu?.toFixed(2) ?? 0,
//   };
// };

const replaceAndEval = ({
  equation,
  modifyPrice,
  key,
  index,
  instrumentsDetail,
  duty,
  buySell,
  diffValue,
}) => {
  const keyName =
    buySell !== null ? (buySell === 0 ? "buy_price_0" : "sell_price_0") : key;

  const createEqu = equation
    .replace(
      /L1/g,
      index === 1 ? modifyPrice : instrumentsDetail?.[1]?.[keyName],
    )
    .replace(/L2/g, index === 0 ? modifyPrice : diffValue)
    .replace(/L3/g, index === 2 ? modifyPrice : instrumentsDetail?.[2]?.[key])
    .replace(/D1/g, duty);

  try {
    const result = new Function(`return ${createEqu}`)();
    return result;
  } catch (error) {
    console.error("Equation evaluation error:", error);
    return 0;
  }
};

export const handleEquationParams = ({
  equation,
  l1Param,
  l2Param,
  l3Param,
  duty,
}) => {
  const createEqu = equation
    .replace(/L1/g, l1Param)
    .replace(/L2/g, l2Param)
    .replace(/L3/g, l3Param)
    .replace(/D1/g, duty);

  try {
    return new Function(`return ${createEqu}`)();
  } catch (error) {
    console.error("Equation evaluation error:", error);
    return 0;
  }
};

const compileEquation = (equation) => {
  return new Function("L1", "L2", "L3", "D1", `return (${equation})`);
};
const toSafe = (v) => (Number.isFinite(+v) ? +v : 0);

export const createBadla = ({ rowData, index, key, buySell = null }) => {
  // if (!rowData || rowData.marketType?.toLowerCase() !== "badla") return 0;
  if (!rowData) return 0;

  const { instrumentsDetail, equation, settingValue, reverse, diffrenceValue } =
    rowData;

  const PRICE = 10000;

  const base0 = instrumentsDetail?.[0]?.[key] || 0;
  const diffValue = diffrenceValue ? base0 + diffrenceValue : base0;

  const priceIndex = instrumentsDetail?.[index]?.[key] || 0;
  const modifyPrice = PRICE / (priceIndex || 1);

  const duty = settingValue?.[0]?.Duty || 0;

  // 👇 cache compiled function on rowData (VERY IMPORTANT)
  if (!rowData._compiledEq) {
    rowData._compiledEq = compileEquation(equation || "0");
  }

  const keyName =
    buySell !== null ? (buySell === 0 ? "buy_price_0" : "sell_price_0") : key;

  const L1 = index === 1 ? modifyPrice : instrumentsDetail?.[1]?.[keyName] || 0;

  const L2 = index === 0 ? modifyPrice : diffValue;

  const L3 = index === 2 ? modifyPrice : instrumentsDetail?.[2]?.[key] || 0;

  const result = rowData._compiledEq(
    toSafe(L1),
    toSafe(L2),
    toSafe(L3),
    toSafe(duty),
  );

  const finalEqu = toSafe(result);

  const finalPrice =
    (reverse ?? 0) === 1 ? finalEqu - diffValue : diffValue - finalEqu;

  return {
    finalPrice: toSafe(finalPrice)?.toFixed(2),
    finalEqu,
  };
};

export const orderPL = ({
  rowData,
  exchangeName,
  type,
  detail,
  dollarRate,
}) => {
  if (!rowData?.[type] || !rowData?.[detail]?.[0])
    return {
      PL: 0,
      PLwithDollar: 0,
      Brokerage: 0,
      Total: 0,
    };

  const BuySell = rowData?.[type];
  const Detail = rowData?.[detail]?.[0];
  const Price = `${exchangeName}Price`;
  const Qty = `${exchangeName}Qty`;
  const isBrokerage = rowData?.checkBrokrage;

  // PL
  const exchangePrice =
    BuySell === "buy" ? Detail?.buy_price_0 : Detail?.sell_price_0;
  const exchangeMultiple = BuySell == "buy" ? 1 : -1;
  const exchangeOpenAvg = rowData[Price];
  const exchangeQty = rowData[Qty];
  const exchangeLotsize = Detail?.lot_size;
  const exchangeResult =
    (exchangePrice - exchangeOpenAvg) *
    exchangeQty *
    exchangeLotsize *
    exchangeMultiple; // with dollar rate
  const exchangeWihoutDollarResult = exchangeResult * dollarRate;

  // Brockerage
  let exchangeBrokerage = 0;
  let exchangeTotal = 0;
  if (isBrokerage) {
    exchangeBrokerage = rowData?.comexBroAmount * exchangeQty * dollarRate;
    exchangeTotal = exchangeResult - exchangeBrokerage;
  }

  return {
    PL: exchangeWihoutDollarResult.toFixed(2) ?? 0,
    PLwithDollar: exchangeResult.toFixed(2),
    Brokerage: exchangeBrokerage.toFixed(2),
    Total: !isBrokerage ? exchangeResult.toFixed(2) : exchangeTotal.toFixed(2),
  };
};

// export const currentBadla = ({ rowData, reverse }) => {
//   const comexPrice =
//     rowData?.comexDetail?.[0]?.[
//       `${rowData?.comexType === "buy" ? "buy_price_0" : "sell_price_0"}`
//     ] || 0;
//   const mcxPrice =
//     rowData?.mcxDetail?.[0]?.[
//       `${rowData?.mcxType === "buy" ? "buy_price_0" : "sell_price_0"}`
//     ] || 0;
//   const dgcxPrice =
//     rowData?.dgcxDetail?.[0]?.[
//       `${rowData?.dgcxType === "buy" ? "buy_price_0" : "sell_price_0"}`
//     ] || 0;
//   const dgcxLPrice = dgcxPrice === 0 ? 0 : 10000 / dgcxPrice;
//   const duty = rowData?.duty || 0;

//   let equation = rowData?.equation;
//   // console.log("🚀 ~ currentBadla ~ equation:", equation);
//   equation = equation.replace("L1", "comexPrice");
//   equation = equation.replace("L1", "comexPrice");
//   equation = equation.replace(/L2/g, "mcxPrice");
//   equation = equation.replace(/L3/g, "dgcxLPrice");
//   equation = equation.replace(/D1/g, "duty");

//   const equ = eval(equation);
//   // console.log("🚀 ~ currentBadla ~ equ:", equ);
//   let finalBadla = reverse && reverse == "1" ? equ - mcxPrice : mcxPrice - equ;
//   // console.log("🚀 ~ currentBadla ~ finalBadla:", finalBadla);

//   return {
//     result: finalBadla ?? 0,
//   };
// };

export const currentBadla = ({ rowData, reverse }) => {
  const comexPrice =
    rowData?.comexDetail?.[0]?.[
      rowData?.comexType === "buy" ? "buy_price_0" : "sell_price_0"
    ] || 0;

  const mcxPrice =
    rowData?.mcxDetail?.[0]?.[
      rowData?.mcxType === "buy" ? "buy_price_0" : "sell_price_0"
    ] || 0;

  const dgcxPrice =
    rowData?.dgcxDetail?.[0]?.[
      rowData?.dgcxType === "buy" ? "buy_price_0" : "sell_price_0"
    ] || 0;

  const dgcxLPrice = dgcxPrice === 0 ? 0 : 10000 / dgcxPrice;
  const duty = rowData?.duty || 0;

  let equation = rowData?.equation || "0";

  equation = equation
    .replace(/L1/g, "comexPrice")
    .replace(/L2/g, "mcxPrice")
    .replace(/L3/g, "dgcxLPrice")
    .replace(/D1/g, "duty");

  let equ = 0;

  try {
    equ = new Function(
      "comexPrice",
      "mcxPrice",
      "dgcxLPrice",
      "duty",
      `return ${equation}`,
    )(comexPrice, mcxPrice, dgcxLPrice, duty);
  } catch (e) {
    console.error("Equation error:", equation, e);
  }

  const finalBadla = reverse === "1" ? equ - mcxPrice : mcxPrice - equ;

  return {
    result: finalBadla || 0,
  };
};

export const isNum = (val) => {
  if (typeof val === "number") return val;

  if (typeof val === "string" && val.trim() !== "") {
    const num = Number(val);
    return isNaN(num) ? 0 : num;
  }

  return 0;
};
